export const login = {
    login: '/jwt/token',

    getUser: '/jwt/user/v2',
    logout: '/api/organization/oauth/loginOut',
    refreshToken: '/api/organization/oauth/token/refresh',
    // getUser: `/jwt/user`,
    // logout: `/jwt/logout`,
    // refreshToken: '/oauth/token',

    sendSMS: '/api/organization/oauth/captcha',
    modifyPassword: '/api/organization/tenant/user/pwd',
    forgetPassword: '/api/organization/tenant/user/pwd/forget',

    /** 极验的接口*/
    getGeetest: '/jwt/initCaptcha',
};
// 消息通知服务
export const MSG_SERVER = {
    production: 'https://msg.zhongbaounion.com',
    uat: 'https://msg.staging.zhongbaounion.com',
    development: 'https://msg.test.zhongbaounion.com',
    dev: 'https://msg.test.zhongbaounion.com',
};
/** 商务合伙人模块*/
const API_PARTNER = '/api/intelligence';
const API_BL_MODEL = '/api/bl-model';
const API_ORGANIZATION = '/api/organization';
const API_ADMIN = '/api/admin';
const API_COMPANY = '/api/company';
const API_INTELLIGENCE = '/api/intelligence';
const API_INTELLIGENCE_BUSSINESS = '/api/intelligence/bussinessReport';

const API_PRODUCT = '/api/product';
const API_COMMISSION = '/api/commission';
const API_POLICY = '/api/policy';
const API_CUSTOMER = '/api/customer';
const MIXED = '/api/mix';
const API_MARKET = '/api/market';
export const MSG_ZHONGBAOUNION = MSG_SERVER[process.env.NODE_ENV];
// export const MSG_ZHONGBAOUNION = ''
//ie兼容
export const other = {
    initSkuOptions: `${API_COMMISSION}/commisionConfOfTenant/initSkuOptions`,
    validateTime: `${API_COMMISSION}/commisionConfOfTenant/validateTime`,
    getCommisionConfDetail: `${API_COMMISSION}/commisionConfOfTenant/getCommisionConfDetail`,
    getProductSpu: `${API_COMMISSION}/scalingCoefficient/getProductSpu`,
    listNew: `${API_COMMISSION}/commisionConfOfAgency/listNew`,
    commisionConfOfTenantList: `${API_COMMISSION}/commisionConfOfTenant/list`,
    fuzzyQuery: `${API_PRODUCT}/productSys/repositorySpu/fuzzyQuery`,
    queryAll: `${API_PRODUCT}/productSys/repositorySpu/query/all`,
    queryPage: `${API_PRODUCT}/productSys/repositoryInfo/query/page`,
    customerAnalyzeAll: `${API_CUSTOMER}/customerAnalyze/all`,
    getCustomerInfoDetails: `${API_CUSTOMER}/customerInfo/getCustomerInfoDetails`,
    getCustomerPolicyInfo: `${API_CUSTOMER}/customerInfo/getCustomerPolicyInfo`,
    getGroupByCompanyId: `${API_CUSTOMER}/customerInfo/getGroupByCompanyId`,
    historyList: `${API_COMMISSION}/commisionConfOfAgency/historyList`,
    scalingCoefficient: `${API_COMMISSION}/scalingCoefficient/historyList`,
    getCompanyInfo: `${API_COMMISSION}/orgCompany/getCompanyInfo`,
    getInsureCompany: `${API_COMMISSION}/scalingCoefficient/getInsureCompany`,
    repositoryShelfPage: `${API_PRODUCT}/productSys/repositoryShelf/query/page`,
    /** 商户佣金配置-产品名称列表*/
    initNewSpuOptions: `${API_COMMISSION}/commisionConfOfTenant/initNewSpuOptions`,
    /** 首页echats数据*/
};

export const laws = {
    addMinusMoneyDelete: `${API_BL_MODEL}/blWagesAdjustment/delete`,
    addMinusMoneyDeletes: `${API_BL_MODEL}/blWagesAdjustment/deletes`,
    addMinusMoneyGetOrgList: `${API_BL_MODEL}/orgCompany/initCompanyList`,
    addMinusMoneyQuery: `${API_BL_MODEL}/blWagesAdjustment/list`,
    addMinusMoneyAdd: `${API_BL_MODEL}/blWagesAdjustment/add`,
    addMinusMoneyUpdate: `${API_BL_MODEL}/blWagesAdjustment/update`,
    addMinusMoneyGetByEmployeeId: `${API_BL_MODEL}/orgAgency/getByEmployeeId`,
    /** 保险公司继续率*/
    insuranceCompany: `${API_BL_MODEL}/persistencyRate/insure`,
    /** 机构继续率*/
    ogrPersistRate: `${API_BL_MODEL}/persistencyRate/company`,
    /** 业务员继续率*/
    salesMan: `${API_BL_MODEL}/persistencyRate/agency`,
    /** 机构等级继续率*/

    initCompanyLevelList: `${API_COMPANY}/orgCompanyLevel/initCompanyLevelList`,
    companyLevelGet: `${API_COMPANY}/orgCompanyLevel/get`,
    companyLevelAdd: `${API_COMPANY}/orgCompanyLevel/add`,

    bonusDetailGetCompanyList: `${API_BL_MODEL}/orgCompany/initCompanyList`,
    bonusDetailQuery: `${API_BL_MODEL}/blWages/dynamicList`,
    bonusDetailGetGroup: `${API_BL_MODEL}/orgCompany/initGroupList`,
    bonusDetailCalculation: `${API_BL_MODEL}/result/calculate`,
    bonusDetailGetList: `${API_BL_MODEL}/result/list`,
    bonusDetailCheckMonth: `${API_BL_MODEL}/result/validateMonth`,
    bonusDetailGetBlList: `${API_BL_MODEL}/blDefinition/initBlDefinitionList`,

    reCalculation: `${API_BL_MODEL}/result/reCalculate`,
    initCompanyList: `${API_BL_MODEL}/orgCompany/initCompanyList`,

    resultConfigGetDetail: `${API_BL_MODEL}/blWagesTemplate/get`,
    resultConfigGetMsg: `${API_BL_MODEL}/blDefinition/getBussiAndBasicNorm`,
    resultConfigGetInitList: `${API_BL_MODEL}/blWagesTemplate/initBlDefinitionList`,
    resultConfigHandleChange: `${API_BL_MODEL}/orgInfo/getOrgInfos`,
    resultConfigSave: `${API_BL_MODEL}/blWagesTemplate/add`,
    resultConfigUpdate: `${API_BL_MODEL}/blWagesTemplate/update`,
    resultConfigGetCompanyList: `${API_BL_MODEL}/blWagesTemplate/initOrgList`,
    resultConfigGetSearch: `${API_BL_MODEL}/blWagesTemplate/list`,
    resultConfigGetDelete: `${API_BL_MODEL}/blWagesTemplate/delete`,

    managerDelete: `${API_BL_MODEL}/blDefinition/deleteBlDefinition`,
    managerGetCompanyList: `${API_BL_MODEL}/blDefinition/initOrgList`,
    managerSearch: `${API_BL_MODEL}/blDefinition/getBlDefinitionList`,
    managerUpdate: `${API_BL_MODEL}/blDefinition/updateBlDefinition`,
    managerAdd: `${API_BL_MODEL}/blDefinition/addBlDefinition`,
    managerGetMsg: `${API_BL_MODEL}/blDefinition/getBlDefinitionDetail`,
    managerAddBusiness: `${API_BL_MODEL}/norm/addBlBusinessNorm`,
    managerUpdateBusiness: `${API_BL_MODEL}/norm/updateBusinessNorm`,
    managerDeleteBusiness: `${API_BL_MODEL}/norm/deleteBusinessNorm`,

    blBusinessList: `${API_BL_MODEL}/blBusinessConfig/list`,
    updateBlBusiness: `${API_BL_MODEL}/blBusinessConfig/update`,
    deleteBlBusiness: `${API_BL_MODEL}/blBusinessConfig/delete`,
};

export const orgManager = {
    orgListSearchList: `${API_ORGANIZATION}/orgInfo/list`,
    orgListGetOnDetail: `${API_ORGANIZATION}/orgInfo/get`,
    orgListGetDetail: `${API_ORGANIZATION}/orgInfo/detail`,
    orgListAdd: `${API_ORGANIZATION}/orgInfo/add`,
    orgListUpdate: `${API_ORGANIZATION}/orgInfo/update`,
    orgListDelete: `${API_ORGANIZATION}/orgInfo/delete`,
    orgListGetOrgTypeList: `${API_ORGANIZATION}/orgInfo/initOrgType`,
    validateOrgName: `${API_ORGANIZATION}/orgInfo/validateOrgName`,
    /** 检查商户内部编码是否合法*/
    validateInnerOrgCode: `${API_ORGANIZATION}/orgInfo/validateOrgInnerCode`,
    validateUsername: `${API_ORGANIZATION}/orgInfo/validateUsername`,

    orgRankQueryList: `${API_ORGANIZATION}/orgRank/list`,
    orgRankGetOrgInfos: `${API_ORGANIZATION}/orgInfo/getOrgInfos`,
    orgRankAdd: `${API_ORGANIZATION}/orgRank/add`,
    orgRankUpdate: `${API_ORGANIZATION}/orgRank/update`,
    orgRankDelete: `${API_ORGANIZATION}/orgRank/delete`,
    getOrgInfosExistsRank: `${API_ORGANIZATION}/orgInfo/getOrgInfosExistsRank`,

    initRankList: `${API_ORGANIZATION}/orgRank/initRankList`,
    //获取商务合伙人列表
    getOrgPartnerList: `${API_PARTNER}/orgPartner/list`,
    //获取商务合伙人详情
    getOrgPartnerDetail: `${API_PARTNER}/orgPartner/get`,
    //新增合伙人
    OrgPartnerAdd: `${API_PARTNER}/orgPartner/add`,
    //新增关联商户
    getOrgPartnerAddRate: `${API_PARTNER}/orgPartner/addRate`,
    //关联商户列表
    getOrgPartnerRateList: `${API_PARTNER}/orgPartner/rateList`,
    //更新
    getOrgPartnerUpdate: `${API_PARTNER}/orgPartner/update`,
    /** 导出合伙人保单*/
    exportOrgPolicyList: `${API_PARTNER}/orgPartner/policyList`,
    OrgPolicyUpdateRate: `${API_PARTNER}/orgPartner/updateRate`,
    /** 模板授权*/
    templateAuth: `${API_POLICY}/billTransTemplate/authTemplates`,
    /** 获取模板名称列表*/
    getTemplateList: `${API_POLICY}/billTransTemplate/initAuthTemplateList`,
    /** 获取结算单保单列表*/
    getSubmitPolicy: `${API_POLICY}/billTransDetail/list`,

    /** 获取下拉框列表（保险公司名称）*/
    getSubmitSelectList: `${API_POLICY}/billTransDetail/initInsureNameList`,
    //homePage
    dashboardInfo: `${API_PARTNER}/dashboard/info`,
};

export const notice = {
    noticeAddAndPush: `${API_ADMIN}/notice/addAndPush`,
    noticePush: `${API_ADMIN}/notice/push`,
    noticeGetList: `${API_ADMIN}/notice/list`,
    noticeAdd: `${API_ADMIN}/notice/add`,
    readList: `${API_ADMIN}/notice/read/list`,
    readAllList: `${API_ADMIN}/notice/read/list/all`,
    updateReadFlag: `${API_ADMIN}/notice/updateReadFlag`,
    updatePassword: `${API_ADMIN}/api/user/updatePwd`,
    /** 产品维护通知-列表*/
    productMaintainList: `${API_PRODUCT}/productMaintain/productMaintainList`,
    /** 产品维护通知-保险公司列表*/
    insureOrgSelector: `${API_PRODUCT}/productMaintain/insureOrgSelector`,
    /** 产品维护通知-产品名称列表*/
    getproductSelector: `${API_PRODUCT}/productMaintain/productSelector`,
    /** 删除*/
    deleteproductMaintain: `${API_PRODUCT}/productMaintain/delete`,
    /** 新增*/
    saveProductMaintain: `${API_PRODUCT}/productMaintain/save`,
    /** 更新*/
    updateProductMaintain: `${API_PRODUCT}/productMaintain/update`,
    noticeListApi: `${API_ORGANIZATION}/message/list`,
    apiMessageRead: `${API_ORGANIZATION}/message/read`,
};

export const companyManager = {
    getGroupTypeList: `${API_COMPANY}/orgGroup/initGroupTypeList`,
    groupAdd: `${API_COMPANY}/orgGroup/add`,
    groupGet: `${API_COMPANY}/orgGroup/get`,
    groupDelete: `${API_COMPANY}/orgGroup/delete`,
    groupGroupLevel: `${API_COMPANY}/orgGroup/initGroupLevelList`,
    groupUpdate: `${API_COMPANY}/orgGroup/update`,
    groupGetList: `${API_COMPANY}/orgGroup/list`,
    initDepartAndGroupList: `${API_COMPANY}/orgGroup/initDepartAndGroupList`,
    groupGetCompanyList: `${API_COMPANY}/orgCompany/initCompanyList`,
    initAllGroupList: `${API_COMPANY}/orgGroup/initAllGroupList`,
    companyAdd: `${API_COMPANY}/orgCompany/add`,
    companyUpdate: `${API_COMPANY}/orgCompany/update`,
    treeListWithGroup: `${API_COMPANY}/orgCompany/treeListWithGroup`,
    treeListWithoutSelf: `${API_COMPANY}/orgCompany/treeListWithoutSelf`,
    companyGetTree: `${API_COMPANY}/orgCompany/treeList`, // 被替代 groupGetTable
    companyGetTreeTable: `${API_COMPANY}/orgCompany/treeTableList`,
    validateCompanyName: `${API_COMPANY}/orgCompany/validateCompanyName`,
    getAgencyByGroupId: `${API_COMPANY}/orgAgency/getAgencyByGroupId`,
    getPeopleList: `${API_COMPANY}/orgAgency/list`,
    addPeople: `${API_COMPANY}/orgAgency/add`,
    updatePeople: `${API_COMPANY}/orgAgency/update`,
    initEducationList: `${API_COMPANY}/orgAgency/initEducationList`,
    initNationList: `${API_COMPANY}/orgAgency/initNationList`,
    getByEmployeeId: `${API_COMPANY}/orgAgency/getByEmployeeId`,
    getPeopleDetail: `${API_COMPANY}/orgAgency/get`,
    deletePeople: `${API_COMPANY}/orgAgency/delete`,
    batchImport: `${API_COMPANY}/orgAgency/batchImport`,
    /*业务员管理新增*/
    salesman_getByName: `${API_COMPANY}/orgAgency/getByName`,
    /** 取消和指定团队长*/
    salesman_updateGroupLeader: `${API_COMPANY}/orgGroup/updateGroupLeader`,
    groupGetTable: `${API_ORGANIZATION}/orgGroup/getGroupList`,
};

export const left = {
    getUserAuthTree: `${API_ADMIN}/menu/user/authorityTree`,
    /** 菜单管理*/
    getMenuTree: `${API_ADMIN}/menu/tree`,
    addMenuTree: `${API_ADMIN}/menu`,
    deleteMenuTree: `${API_ADMIN}/menu`,
    areaDictList: `${API_ADMIN}/areaDict/list`,
    // areaDictList: `${API_ADMIN}/areaDict/getAreaDictList`,//获取地区
    getCardTypes: `${API_ADMIN}/baseDict/getByDictType`, //获取证件类型
    initTeamLeaderList: `${API_COMPANY}/orgAgency/initTeamLeaderList`,
};

export const report = {
    orgReport: `${API_INTELLIGENCE_BUSSINESS}/orgReport`,
    agentReport: `${API_INTELLIGENCE_BUSSINESS}/agentReport`,
    insureOrgReport: `${API_INTELLIGENCE_BUSSINESS}/insureOrgReport`,
    spuReport: `${API_INTELLIGENCE_BUSSINESS}/spuReport`,
    totalReport: `${API_INTELLIGENCE_BUSSINESS}/totalReport`,
    /** 商户业务统计列表*/
    getOrgBussinessReport: `${API_INTELLIGENCE}/orgBussinessStatistics/getOrgBussinessReport`,
    /** 商户业务统计-下拉框*/
    tenantSelectors: `${API_PRODUCT}/prdContrast/tenantSelector`,
    /** 商户业务统计-下拉框*/
    productSelectors: `${API_INTELLIGENCE}/orgBussinessStatistics/productSelector`,
    /** 商户业务统计-下拉框*/
    insureOrgSelector: `${API_INTELLIGENCE}/orgBussinessStatistics/insureOrgSelector`,
    allProductCategory: `${API_PRODUCT}/product/def/allProductCategory`,
    feeRateCompanyProductCategoryLis: '/api/commission/feeRateCompany/productCategory/list',
    feeRateGroupAgencyProductCategoryList: '/api/commission/feeRateGroupAgency/productCategory/list',

    /** 发送短信验证码*/
    sendSmsForUpdatePwd: `${API_ADMIN}/sms/sendSmsForUpdatePwd`,
    /** 忘记密码提交*/
    fogetpassword: `${API_ADMIN}/sms/forgetPwd`,
};

export const policy = {
    offlinePolicyList: `${API_POLICY}/offlinePolicy/list`,
    offlinePolicyList1: `${API_POLICY}/offlinePolicy/listorg`,
    deletePolicyList: `${API_POLICY}/offlinePolicy/delete`,
    getPolicyListDetail: `${API_POLICY}/offlinePolicy/get`,
    initInsureOrgList: `${API_POLICY}/offlinePolicy/initInsureOrgList`,
    addOrgList: `${API_POLICY}/offlinePolicy/add`,
    updateOrgList: `${API_POLICY}/offlinePolicy/update`,
    unConfirmSettlementCount: `${API_POLICY}/policySettlement/org/unConfirmSettlementCount`,
    /**  团队选择器(级联)*/
    orgGroupSelectors: '/api/intelligence/platformOrder/orgGroupSelector',
    /**  公司选择器(级联) */
    orgCompanySelector: '/api/company/orgCompany/orgCompanySelector',
};
export const policyPlatform = {
    /** 商户类型下拉列表*/
    orgTypeSelector: '/api/intelligence/platformOrder/orgTypeSelector',
    /** 商户名称列表*/
    orgInfoSelectors: '/api/intelligence/platformOrder/orgInfoSelector',
};
/** 系统管理*/
export const systemAPI = {
    /** 商户平台-账号管理-获取商户名下的用户列表数据*/
    getUserList_account: `${API_ADMIN}/user/list/v2`,
    /** 商户平台-账号管理-获取公司列表（下拉框）*/
    getSelectList_account: `${API_ADMIN}/orgCompany/initCompanyList`,
    /** 商户平台-账号管理-新增*/
    doAdd_account: `${API_ADMIN}/user/add`,
    /** 商户平台-账号管理-获取详情*/
    getDetailJson_account: `${API_ADMIN}/user/get`,
    /** 商户平台-账号管理-更新详情*/
    upDateDetailJson_account: `${API_ADMIN}/user/update`,
    /** 商户平台-账号管理-角色授权列表接口*/
    getAuthorList_account: `${API_ADMIN}/baseGroup/userGroupMenulist`,
    /** 商户平台-账号管理-进行授权*/
    doAuth_account: `${API_ADMIN}/baseGroup/authorizedGroupToUser`,
    /** 商户平台-账号管理-取消授权*/
    removeAuth_account: `${API_ADMIN}/baseGroup/revokeGroupFromUser`,
    /** 商户平台-账号管理-取消授权*/
    getRoleList_account: `${API_ADMIN}/baseGroup/list`,
    /** 商户平台-角色详情数据*/
    getTreeDate_baseGroup: `${API_ADMIN}/baseGroup/get`,
    /** 商户平台-角色管理-新增角色*/
    addRole_baseGroup: `${API_ADMIN}/baseGroup/add`,
    /** 商户平台-角色管理-获取新增页面的树形数据*/
    getAddTreeData_role: `${API_ADMIN}/menu/user/authorityTree2`,
    /** 商户平台-角色管理-更新详情数据*/
    updateDetail_role: `${API_ADMIN}/baseGroup/update`,
    /** 菜单管理-新增页面-下拉框数据*/
    getMenuTree_role: `${API_ADMIN}/menu/treeWithTop`,
    /** 菜单管理-新增页面-新增接口*/
    addMenuTree_role: `${API_ADMIN}/menu/add`,
    /** 菜单管理-index页面-保存更新*/
    updateMenuTree_role: `${API_ADMIN}/menu/update`,
    /** 菜单管理-index页面-保存更新*/
    deleteMenuTree_role: `${API_ADMIN}/menu/delete`,
    /** 菜单管理-详情页面-获取详情*/
    getDetail_menu: `${API_ADMIN}/menu/get`,
    getDetail_policy: `${API_PARTNER}/policy/detail`,
    getDetail_platform_policy: `${API_PARTNER}/platformPolicy/detail`,
    /** 线上订单详情*/
    online_order_list: `${API_PARTNER}/order/detail`,
    /** 平台线上订单详情*/
    online_order_list_platform: `${API_PARTNER}/platformOrder/detail`,
    /** 商户品牌配置-获取配置*/
    getOrgBrand: `${API_ORGANIZATION}/orgBrand/getDetails`,
    /** 商户品牌配置-更新配置*/
    updateOrgBrand: `${API_ORGANIZATION}/orgBrand/save`,
};
/** 考勤管理*/
export const attendance = {
    /** (考勤项目)下拉框列表接口*/
    initSelectList_manager: `${API_BL_MODEL}/blAttendanceProject/initSelections`,
    /** (考勤项目)更新考勤状态*/
    updateAttendaceStatus_manager: `${API_BL_MODEL}/blAttendance/update`,
    /** （考勤状态）下拉框列表接口*/
    initAttendanceStatusList_manager: `${API_ADMIN}/baseDict/getByDictType?dictType=attendance_status`,
    /** 获取考勤列表*/
    getAttendaceList_manager: `${API_BL_MODEL}/blAttendance/list`,
    /** 删除一条考勤信息*/
    deleteAttendace_manager: `${API_BL_MODEL}/blAttendance/delete`,
    /** 获取考勤项目列表*/
    attendanceProject: `${API_BL_MODEL}/blAttendanceProject/list`,
    /** 删除考勤项目*/
    attendanceProjectDelete: `${API_BL_MODEL}/blAttendanceProject/delete`,
    /** 新增考勤项目列表*/
    attendanceProjectAdd: `${API_BL_MODEL}/blAttendanceProject/add`,
    /** 获取考勤统计列表*/
    attendanceStatistics: `${API_BL_MODEL}/blAttendance/listTotal`,
};
/* 微投保 */
export const weitoubao = {
    getRepositorySubList: '/api/product/insure/repositorySubList',
    getRepositoryList: '/api/product/insure/repositoryList',
    updateByRepositoryId: '/api/product/insure/updateByRepositoryId',
};
export const financeSettle = {
    /** 查询钱包功能列表*/
    withdrawQueryByPage: `${MIXED}/withdraw/queryByPage`,
    /** 更新提现状态*/
    withdrawUpdateStatus: `${MIXED}/withdraw/updateStatus`,
    /** 导出*/
    withdrawExport: `${MIXED}/withdraw/export`,
    /** 收款管理-列表查询*/
    settlement_policySettlement_list: `${API_POLICY}/policySettlement/list`,
    /** 收款管理-获取机构列表*/
    settlement_policySettlement_getSupplyInfo: `${API_POLICY}/policySettlement/getSupplyInfo`,
    /** 收款管理-生成结算单*/
    settlement_policySettlement_createGathering: `${API_POLICY}/policySettlement/create/gathering`,
    /** 收款管理-更新*/
    settlement_policySettlement_update: `${API_POLICY}/policySettlement/update`,
    /** 付款-列表*/
    settlement_policySettlement_paymenList: `${API_POLICY}/policySettlement/paymenList`,
    /** 付款-生成付款单*/
    settlement_policySettlement_create: `${API_POLICY}/policySettlement/create/paymen`,
    /** 付款-获取机构列表*/
    settlement_policySettlement_getPaymenOrgInfo: `${API_POLICY}/policySettlement/getPaymenOrgInfo`,
    /** 预付款*/
    settlement_policySettlement_prepay: `${API_POLICY}/policySettlement/create/prepay`,
    /** 检查日期是否在合法范围内*/
    settlement_policySettlement_queryWhetherPaymen: `${API_POLICY}/policySettlement/queryWhetherPaymen`,
    /** 状态-查询*/
    settlement_policySettlement_policyList: `${API_POLICY}/policySettlement/policyList`,
    /** 状态-修改*/
    settlement_policySettlement_updatePolicyStatus: `${API_POLICY}/policySettlement/updatePolicyStatus`,
    /** 提现申请-列表*/
    settlement_policySettlement_withdrawDepositRecord_list: `${API_POLICY}/withdrawDepositRecord/listCompanyWithdraw`,
    settlement_policySettlement_withdrawDepositRecord_updateWithdrawByIds: `${API_POLICY}/withdrawDepositRecord/updateCompanyWithdrawByIds`,
    /** 是否有权限开通钱包*/
    settlement_getOrginfoByCompanyId: '/api/organization/orgCompany/getOrginfoByCompanyId',
    /** 是否开通了钱包功能*/
    settlement_organization_getCompany: '/api/organization/orgCompany/getCompany',
    /** 去开通钱包*/
    settlement_updateWalletFlag: '/api/organization/orgCompany/updateWalletFlag',
    /** 所属团队*/
};
/*财务结算*/
export const financeSettlement = {
    /*推广收入明细-初始化保险公司 --旧*/
    // settlement_getOrgInfoSelector:`${API_PARTNER}/finSet/getOrgInfoSelector`,
    /*推广收入明细-初始化保险公司*/
    settlement_getOrgInfoSelector: `${API_PARTNER}/finSet/initInsureOrgInfo`,
    /*推广收入明细-查询*/
    settlement_getCompanyFSPI: `${API_PARTNER}/finSet/getCompanyFSPI`,
    /*机构结算-查询*/
    settlement_getOrgFS: `${API_PARTNER}/finSet/getOrgFS`,
    /*业务员结算-初始化团队option*/
    settlement_getOrgGroupSelector: `${API_PARTNER}/finSet/getOrgGroupSelector`,
    /*业务员结算-查询*/
    settlement_getAgentFS: `${API_PARTNER}/finSet/getAgentFS`,
    /*运营-商户佣金结算*/
    settlement_getTenantFS: `${API_PARTNER}/finSet/getTenantFS`,
};
/*费用管理 费率配置*/
export const feeRate = {
    /*机构费率配置 查询*/
    feeRate_org_list: `${API_COMMISSION}/feeRateCompany/list`,
    feeRate_org_list_v1: `${API_COMMISSION}/feeRateCompany/rate/list`,
    feeRateGroupAgencyList: `${API_COMMISSION}/feeRateGroupAgency/rate/list`,
    /*机构费率配置 初始化机构option*/
    feeRate_org_initCompanyOptions: `${API_COMMISSION}/feeRateCompany/initCompanyOptions`,
    /*机构费率配置 操作记录*/
    feeRate_org_historylist: `${API_COMMISSION}/feeRateCompanyHistory/list`,
    /*业务员费率配置 查询*/
    feeRate_salesman_list: `${API_COMMISSION}/feeRateGroupAgency/list`,
    /*业务员费率配置 初始化团队Option*/
    feeRate_salesman_initGroupOptions: `${API_COMMISSION}/feeRateGroupAgency/initGroupOptions`,
    /*feeRateGroupAgencyHistory/list*/
    feeRate_salesman_historylist: `${API_COMMISSION}/feeRateGroupAgencyHistory/list`,
    /** 推广费批量设置*/
    updateBatch: `${API_COMMISSION}/commisionConfOfAgency/updateBatch`,
    initAllSpuOptions: `${API_COMMISSION}/commisionConfOfTenant/initAllSpuOptions`,
    getTemplateCommisionDetail: `${API_COMMISSION}/commisionConfOfTenant/getTemplateCommisionDetail`,
    batchAddCommisionConf: `${API_COMMISSION}/commisionConfOfTenant/batchAddCommisionConf`,
    spuList: `${API_COMMISSION}/feeRateCompany/spu/list`,
    feeRateGroupAgencySpuList: `${API_COMMISSION}/feeRateGroupAgency/spu/list`,
    getSameLevelCompanyList: '/api/company/orgCompany/getSameLevelCompanyList',
    getOtherGroupList: '/api/company/orgGroup/getOtherGroupList',
    treeListWithGroup2: '/api/company/orgCompany/treeListWithGroup2',
};
export const freeOrder = {
    getFreeOrderList: '/api/intelligence/freePolicy/list',
    getFreeOrderSysList: '/api/intelligence/freePolicy/adminList',
    getFreeOrderDetail: '/api/intelligence/freePolicy/detail',
    getTeamList: '/api/intelligence/freePolicy/getGroup',
    queryTopOrgCompanyList: '/api/intelligence/freePolicy/queryTopOrgCompanyList',
    cancelPolicy: '/api/intelligence/cancelPolicy/list',
    cancelPolicyUpdateState: '/api/intelligence/cancelPolicy/updateState',
    cancelPolicyupdateStateTB: '/api/intelligence/cancelPolicy/updateStateTB',
};

/** 展业端配置*/
export const shopDesign = {
    /** 查询展业端配置列表数据*/
    shopDesign_getList: `${API_MARKET}/productPrivate/list`,
    /** 自定义产品图片*/
    shopDesign_uploadImage: `${API_MARKET}/productPrivate/uploadImage`,
    /** 展业端配置-新增产品*/
    shopDesign_addProcut: `${API_MARKET}/productPrivate/add`,
    /** 展业端配置-更新产品*/
    shopDesign_updateProduct: `${API_MARKET}/productPrivate/update`,
    /** 展业端配置-编辑页查询*/
    shopDesign_getDetail: `${API_MARKET}/productPrivate/get`,
    /** 展业端配置-删除一款产品*/
    shopDesign_deleteProduct: `${API_MARKET}/productPrivate/delete`,
    /** 展业端配置-获取产品种类下拉框（新增页、详情页）*/
    shopDesign_getKinfList: `${API_MARKET}/common/getProductCategory`,
    /** 展业端配置-获取产品种类下拉框（index页）*/
    shopDesign_getCategoryList: `${API_MARKET}/productPrivate/getExistsProductCategory`,
    /** 保险公司下拉框（新增/编辑页面）*/
    shopDesign_getCompany: `${API_MARKET}/common/getInsuranceCompanyList`,
    /** 保险公司下拉框（index页面）*/
    shopDesign_getCompanyList: `${API_MARKET}/productPrivate/getExistsInsuranceCompanyList`,
    /** 更新产品上下线状态*/
    shopDesign_updateStatus: `${API_MARKET}/productPrivate/updateStatus`,
    /** 装修首页-查看预览数据*/
    shopDesign_getShowListShow: `${API_MARKET}/design/getOrgDesign`,
    /** 装修展示页-获取展示数据*/
    shopDesign_getShowList: `${API_MARKET}/design/getOrgDesignEdit`,
    /** 装修展示页-上传轮播图*/
    shopDesign_uploadScrollImage: `${API_MARKET}/design/uploadBanner`,
    /** 装修展示页-上传热销产品图*/
    shopDesign_uploadHotImage: `${API_MARKET}/design/uploadShow`,
    /** 装修展示页-保存展示数据*/
    shopDesign_doSaveList: `${API_MARKET}/design/save`,
    /** 模糊搜索商品*/
    shopDesign_searcheProduct: `${API_MARKET}/design/getProductList`,
};

/** 产品对比*/
export const productComparison = {
    /** 产品列表*/
    productComparisonProductList: `${API_PRODUCT}/prdContrast/productList`,
    /** 运营平台-商户列表*/
    tenantList: `${API_PRODUCT}/prdContrast/tenantList`,

    productSelector: `${API_PRODUCT}/prdContrast/productSelector`,

    tenantSelector: `${API_PRODUCT}/prdContrast/tenantSelector`,
    /** 批量修改产品上下线状态*/
    productUpdateStatus: `${API_PRODUCT}/prdContrast/updateStatus`,
    batchOnShelf: `${API_PRODUCT}/prospectusConfig/batchOnShelf`,
};

/** 计划书*/
export const planBook = {
    queryProspectusNameByOrgIdList: `${API_PRODUCT}/prospectusConfig/queryProspectusNameByOrgIdList`,

    queryInsurerBrandNamesList: `${API_PRODUCT}/prospectusConfig/queryInsurerBrandNameForProsList`,
    /** 查询计划书列表*/
    queryProspectusList: `${API_PRODUCT}/prospectusConfig/queryProspectusList`,
    /** 更新计划书状态*/
    updateProspectusStatus: `${API_PRODUCT}/prospectusConfig/updateProspectusStatus`,
    queryProspectusTypes: `${API_PRODUCT}/prospectusConfig/queryProspectusTypes`,
};

/**
 * 线上订单喝线上保单导出明细
 */
export const orderAndPolicyExport = {
    exportOrderDetail: '/api/intelligence/order/exportProposalInfoExcel',
    exportPolicyDetail: '/api/grain-buds-insure-policy/merchant/export/policy/info',
};
